import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { AwardableNegotiationResponse } from "../types";
import { queryKeys } from "./queryKeys";

const fetchAwardableNegotiations = async (): Promise<
  AwardableNegotiationResponse[]
> => {
  const { data } = await axios.get("/purchase-orders/awardable-negotiations");
  return data;
};

/**
 * Awarded negotiations that can still become an OC, one row per (order|group, supplier,
 * currency). Only fetched while `enabled` (the picker modal is open) so the list page doesn't hit
 * the endpoint for viewers who never open it.
 */
export const useAwardableNegotiations = (enabled = true) =>
  useQuery<AwardableNegotiationResponse[], Error>({
    queryKey: [queryKeys.AWARDABLE_NEGOTIATIONS],
    queryFn: fetchAwardableNegotiations,
    enabled,
  });
